import React, { createContext, useState, ReactNode, useContext } from "react";

interface CastSenderContextProps {
  castFrameworkLoaded: boolean;
  setCastFrameworkLoaded: (loaded: boolean) => void;
  castSenderLoaded: boolean;
  setCastSenderLoaded: (loaded: boolean) => void;
}

const CastSenderContext = createContext<CastSenderContextProps | undefined>(
  undefined
);

export const CastSenderProvider = ({ children }: { children: ReactNode }) => {
  const [castFrameworkLoaded, setCastFrameworkLoaded] = useState(false);
  const [castSenderLoaded, setCastSenderLoaded] = useState(false);

  return (
    <CastSenderContext.Provider
      value={{
        castFrameworkLoaded,
        setCastFrameworkLoaded,
        castSenderLoaded,
        setCastSenderLoaded,
      }}
    >
      {children}
    </CastSenderContext.Provider>
  );
};

export const useCastSenderContext = () => {
  const context = useContext(CastSenderContext);
  if (!context) {
    throw new Error(
      "useCastSenderContext must be used within a CastSenderProvider"
    );
  }
  return context;
};
